module.exports = __webpack_public_path__ + "img/bg_img_dps.35c0d604.png";